export default __webpack_public_path__ + "static/media/logo.3d2a9d55.png";